import React from 'react';
import { Phone, Search, CalendarCheck, Wrench, Info } from 'lucide-react';
export function QuoteProcess() {
  const steps = [{
    number: '1',
    icon: Phone,
    title: 'Call or Request an Urgent Quote',
    copy: 'Call 517-545-7772 for fastest help or submit the short form.'
  }, {
    number: '2',
    icon: Search,
    title: 'Confirm the Damage',
    copy: 'The team will ask about your vehicle, which glass is broken, whether it is safe to drive, and whether photos are available.'
  }, {
    number: '3',
    icon: CalendarCheck,
    title: 'Check Glass & Schedule Availability',
    copy: "Kosin's Glass confirms glass availability, insurance details and the fastest appointment options."
  }, {
    number: '4',
    icon: Wrench,
    title: 'Repair, Replace & Calibrate If Needed',
    copy: 'Certified technicians complete the repair or replacement. ADAS calibration is handled if required after windshield replacement.'
  }];
  const sidebarItems = ['Vehicle year, make and model', 'Which glass is damaged', 'Photo of the damage', 'Insurance company information', 'Whether the vehicle is safe to drive', 'Best callback number'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-973" data-mp="2wu0uttj9ozfg">
      <div className="max-w-7xl mx-auto" data-id="element-974" data-mp="30u1m4ergt53x">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-975" data-mp="2mvk0cml4e2on">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-normal leading-tight" data-id="element-976" data-mp="2my68oofu4m7x">
            How Your{' '}
            <span className="text-emergencyBrand-red" data-id="element-977" data-mp="2dw6q3rp69a2v">
              Emergency Auto Glass Quote
            </span>{' '}
            Works
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-978" data-mp="c420wnz24qvu">
          {/* Steps */}
          <div className="lg:col-span-2 space-y-5" data-id="element-979" data-mp="c27ef5850qpn">
            {steps.map((step, i) => <div key={i} className="bg-white rounded-lg p-6 border border-slate-200 flex gap-5 items-start shadow-sm" data-id="element-980" data-mp="g3j5zgaknm0h" data-mpi={i}>
                <div className="shrink-0 w-12 h-12 sm:w-14 sm:h-14 bg-emergencyBrand-red rounded-full flex items-center justify-center text-white font-black text-xl shadow-sm" data-id="element-981" data-mp="1k2pnngsafvav">
                  {step.number}
                </div>
                <div data-id="element-982" data-mp="1b4vu2dlwrfre">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-983" data-mp="27stpbilx1kz8">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-984" data-mp="23sj819sob852">{step.copy}</p>
                </div>
              </div>)}
          </div>
          {/* Sidebar */}
          <div className="lg:col-span-1" data-id="element-985" data-mp="1u1wwprrzp3s6">
            <div className="bg-white rounded-lg p-6 sm:p-7 shadow-sm border border-slate-200 sticky top-6" data-id="element-986" data-mp="1u0vjbgni457a">
              <div className="flex items-center gap-2.5 mb-5" data-id="element-987" data-mp="2rim03pwl8e3o">
                <div className="bg-emergencyBrand-redLight p-2 rounded-md" data-id="element-988" data-mp="2mq2imhus4ytl">
                  <Info className="w-5 h-5 text-emergencyBrand-red" data-id="element-989" data-mp="2u1qnxepbwrvn" />
                </div>
                <h3 className="text-lg font-bold text-slate-900" data-id="element-990" data-mp="2z0k5bi7ql313">
                  For faster help, have these ready:
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-991" data-mp="33y3ieesp79rg">
                {sidebarItems.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-992" data-mp="3821juw5hwwno" data-mpi={i}>
                    <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-emergencyBrand-red flex items-center justify-center" data-id="element-993" data-mp="3d0usob9u7zhi">
                      <span className="w-1.5 h-1.5 bg-emergencyBrand-red rounded-full" data-id="element-994" data-mp="3hxlc98kupd7o" />
                    </span>
                    <span className="text-slate-700 text-sm" data-id="element-995" data-mp="3msih03b3l0er">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}